import {IGlobalStateInit, REDUCER} from "./interface";

const reducer = (state: IGlobalStateInit, action: {type: string, value: any}) => {
    switch (action.type) {
        case REDUCER.SET_NEW_INITIAL_STATE:
            return Object.assign(state, action.value)
        case REDUCER.UPDATE_THEME_CONFIG:
            const themeConfig = Object.assign({}, state.themeConfig, action.value)
            return Object.assign({}, state, {themeConfig})
        case REDUCER.CREATE_NOTIFICATIONS: {
            return Object.assign({}, state, {notifications: action.value})
        }
        case REDUCER.UPDATE_NOTIFICATIONS: {
            let notifications = JSON.parse(JSON.stringify(state.notifications))

            notifications[action.value.name] = notifications[action.value.name] || {};
            if (action.value.count?.action === "inc") {
                notifications[action.value.name].count = (notifications[action.value.name].count || 0) + action.value.count.value;
            } else if (action.value.count?.action === "replace") {
                notifications[action.value.name].count = action.value.count.value;
            } else if (action.value.date)
                notifications[action.value.name].date = action.value.date;
            return Object.assign({}, state, {notifications})
        }
        case REDUCER.UPDATE_TOKEN:
            return { ...state, ...{token: action.value} };
        case REDUCER.UPDATE_USER:
            const user = Object.assign({}, state.user, action.value)
            return { ...state, ...{user} };
        case REDUCER.UPDATE_COMPANY:
            const company = Object.assign({}, state.company, action.value)
            return { ...state, ...{company} };
        case REDUCER.UPDATE_WORKPLACE:
            const workplace = Object.assign({}, state.workplace, action.value)
            return { ...state, ...{workplace} };
        case REDUCER.COLLAPSE_SIDEBAR:
            return { ...state, ...{sideBarCollapsed: action.value} };
        case REDUCER.ADD_SOCKET_EVENT:
            let socketEvents = Object.assign({}, state.socketEvents, action.value.value);
            return  { ...state, ...{socketEvents: JSON.parse(JSON.stringify(socketEvents))} };
        case REDUCER.REMOVE_SOCKET_EVENTS:
            let notReadEvents = Object.keys(state.socketEvents || {}).reduce((res : any, key: string) => {
                if (!action.value.includes(key))
                    res[key] = state.socketEvents?.[key];
                return res;
            }, {});
            return  Object.assign({}, state, { socketEvents: notReadEvents });
        case REDUCER.UPDATE_CALL_STATUS:
                return { ...state, ...{callInProgress: action.value} };
        default:
            return state;
    }
};
export default  reducer;
